import dayjs from 'dayjs';

// Add any plugins you want to use with Day.js
import 'dayjs/locale/et';
import utc from 'dayjs/plugin/utc';
import localizedFormat from 'dayjs/plugin/localizedFormat';

dayjs.extend(utc);
dayjs.locale('et');
dayjs.extend(localizedFormat);

export default dayjs;
